<template>
    <div class="container loginWrap">
       <div class="backWrap" >
           <span @click="back">
               &lt; 返回
           </span>
           
       </div>
       <!-- <div class="title">
           登录
       </div> -->
       <ul>
           <li class="line">
               <span  class="label">
                   手机号
               </span>
               <input type="number" v-model.trim="form.phone" maxlength="11" placeholder="请输入手机号">
           </li>
           <li class="line codeLine">
               <span  class="label">
                   验证码
               </span>
               <input type="number" v-model="form.code" placeholder="请输入验证码">
               <button @click="sentCode" class="codeBtn" :disabled="isDisabledCode">{{codeBtnMsg}}</button>
           </li>
       </ul>
       <div class="buttonBox">
           <div>
               <button @click="login" class="loginBtn">登录</button>
           </div>
           <div class="hrefBtn">
               <span @click="toApply" class="applyBtn">未报名，点击去报名>></span>
           </div>
       </div>
        
    </div>
</template>
<script>
import { validateMobile, validateIdCard } from '@/utils/validate'
import { RequestPhoneLoginCode, phoneCodeLogin } from '@/api/index'
export default {
	name: 'login',
	data() {
		return {
			tab: '1',
			form: {
                
			},
			send: true,
			number: 60,
			currentPicker: {
				title: '',
				type: '',
			},
			redirect: null ,
             isDisabledCode:false,
             codeBtnMsg:"发送验证码",
		}
	},
	watch: {
		$route: {
			handler: function(route) {
				this.redirect = route.query && route.query.redirect
			},
			immediate: true
		}
	},
	methods: {
        back(){
            this.$router.back()
        },
        toApply(){
            this.$router.push("/apply")

        },
		login() {
            let _this=this
            if(!_this.checkPhone () ){
                return false
            }
            if(!_this.form.code){
                this.$cToast('请输入验证码')
                return false
			}
			phoneCodeLogin({
				"phone": _this.form.phone,
				"code": _this.form.code,
				"userDeviceInfo": navigator.userAgent,
			}).then(res => {
                if(res.errorCode==200){
                    this.$createToast({
                    	txt: '登录成功',
                    	type: 'txt'
                    }).show();
                    this.$store.dispatch('Login', {
                    	token: res.data.token,
                    	userId: res.data.user_id
					})
					this.$router.push({ path: this.redirect || '/certificate' })
                } else{
                    this.$createToast({
                    	txt: res.errorMsg,
                    	type: 'txt'
                    }).show();
                }
				
			}).catch(err => {
			
			})
		},
		sentCode() {
			console.log(process,"process.env.BASE_API",process.env.NODE_ENV, process.env.VUE_APP_URLENV)
            let _this=this
            let timer;
			if (this.checkPhone() && this.send) {
                let num=60
                 _this.codeBtnMsg=num+"s"
                _this.isDisabledCode=true
                timer=setInterval(function(){
                    if(num>1){
                        num--
                        _this.codeBtnMsg=num+"s"
                        _this.isDisabledCode=true
                    }else{
                        clearInterval(timer)
                        _this.codeBtnMsg='发送验证码'
                        _this.isDisabledCode=false
                    }
                    
                },1000)
				RequestPhoneLoginCode({phone: this.form.phone}).then((res) => {
					if (res.errorCode == 200) {
						this.$createToast({
							txt: '验证码发送成功',
							type: 'txt'
						}).show();
                        
					} else {
                        clearInterval(timer)
                        _this.codeBtnMsg='发送验证码'
                        _this.isDisabledCode=false
						this.$createToast({
							txt: res.errorMsg,
							type: 'txt'
						}).show()
					}
				}).catch(err => {
                    console.log(timer)
                    clearInterval(timer)
                    _this.codeBtnMsg='发送验证码'
                    _this.isDisabledCode=false
					this.$createToast({
						txt: '验证码发送失败',
						type: 'txt'
					}).show()
				})
			}
		},
		// 前端较验手机号
		checkPhone () {
			if (this.form.phone == '') {
				this.$cToast('请输入手机号')
				return false
			}
			if (!validateMobile(this.form.phone)) {
				this.$cToast('手机号格式不正确')
				return false
			}
			return true
		},
	}
}
</script>


<style scoped>
    /* *{outline: 1px solid blue;} */
    .loginWrap.container{padding:0.75rem 0.5rem;}
   .loginWrap .backWrap{
        font-size: 0.35rem;padding:0.5rem 0; letter-spacing: 1px;;font-weight: bold;
    }
   .loginWrap .title{font-size: 0.3rem;color:#DF7A32;margin:0.2rem 0;font-size: 0.32rem;}
   .loginWrap .line{padding:0.25rem 0;}
   .loginWrap .codeLine{position: relative;}
   .loginWrap .codeBtn{cursor: pointer; background: #fff;border:1px solid #DF7A32;border-radius: 0.1rem;padding:0.1rem 0.15rem;color:#DF7A32;position: absolute;top:0;right:0.2rem;}
    .loginWrap .codeBtn:hover{background: #DF7A32;color:#fff;}
    .loginWrap .codeBtn[disabled]{background: #ddd;border-color: #ddd;color:#fff;}
   .loginWrap .label{display: inline-block;width: 1.2rem; text-align: justify;text-align-last: justify; margin-right: 0.2rem;font-weight: bold;}
   .loginWrap input{border-bottom: 1px solid #aaa;padding:0.1rem 0.2rem;width: 5rem;}
   .loginWrap .buttonBox{
        margin-top:1rem;padding-left:1.4rem;
    }
  .loginWrap  .loginBtn{ background: #DF7A32;color:#fff;padding:0.15rem 0.5rem;border-radius: 0.1rem;}
  .loginWrap  button{letter-spacing: 2px;;}
   .loginWrap  .applyBtn{color:#DF7A32;font-weight: bold;}
   .hrefBtn{
       text-align: left;margin-top:0.4rem;
   }
</style>

